import { render, staticRenderFns } from "./ElCascaderTest.vue?vue&type=template&id=6cb34d92&scoped=true"
import script from "./ElCascaderTest.vue?vue&type=script&lang=js"
export * from "./ElCascaderTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.6.14_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb34d92",
  null
  
)

export default component.exports